import { render, staticRenderFns } from "./News Details.vue?vue&type=template&id=5dbbb1e9&scoped=true&"
import script from "./News Details.vue?vue&type=script&lang=js&"
export * from "./News Details.vue?vue&type=script&lang=js&"
import style0 from "./News Details.vue?vue&type=style&index=0&id=5dbbb1e9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dbbb1e9",
  null
  
)

export default component.exports